export default "__VITE_PUBLIC_ASSET__2d80f44d__"